import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline, pathTargets } from "./_helpers";

// "Assemble" — each path rotates and scales into position with a short
// stagger. The whole-logo wrapper does a parallel scale-from-90% so the mark
// "tightens" as the parts lock in. Path skew goes to 0 in lockstep.
export const morph: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  const targets = pathTargets(logo);
  const n = Math.max(1, targets.length);
  const stagger = Math.min(0.12, 0.45 / n);

  return {
    ...base,
    tracks: [
      {
        target: ROOT_TARGET,
        easing: "easeOutExpo",
        delay: 0,
        keyframes: [
          { t: 0,    opacity: 0, scale: 0.94 },
          { t: 0.6,  opacity: 1, scale: 1.01 },
          { t: 1,    opacity: 1, scale: 1 },
        ],
      },
      ...targets.map((sel, i) => {
        const start = i * stagger;
        const land = Math.min(start + 0.55, 0.95);
        const dir = i % 2 === 0 ? 1 : -1;
        return {
          target: sel,
          easing: "easeOutExpo" as const,
          delay: 0,
          keyframes: [
            { t: 0,                  opacity: 0, scale: 0.5, rotate: -14 * dir, skewX: 6 * dir },
            { t: start,              opacity: 0, scale: 0.5, rotate: -14 * dir, skewX: 6 * dir },
            { t: land,               opacity: 1, scale: 1.04, rotate: 2 * dir, skewX: 0 },
            { t: 1,                  opacity: 1, scale: 1,    rotate: 0,        skewX: 0 },
          ],
        };
      }),
    ],
  };
};
